import React from 'react';
import { Link } from 'react-router';

function renderSimplePopup(popup, { click }) {
	return popup.content.link ? (
		<Link
			to={popup.content.link}
			target='_blank'
			onClick={click}
			key={popup.id}
		>
			<img src={popup.content.image} />
		</Link>
	) : (
		<img src={popup.content.image} />
	);
}

export default renderSimplePopup;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/popup-window/popup/render-popup/render-simple-popup/index.js